export default "__VITE_ASSET__HJSpeuhJ__"